module.exports = __webpack_public_path__ + "static/media/token-placed.d449f05a.mp3";